import { useContext, useEffect, useState } from 'react';
import ReactModal from 'react-modal';

import { GroupDetailInterface, UserGroupInterface } from 'types/user';
import { ModalContext } from 'context/ModalContext';
import Box from 'components/ui/box';
import { useAuth } from 'context/AuthContext';
import { getUserGroup, getUserGroupList } from 'services/dashboard.service';

import { IoIosClose } from 'react-icons/io';
import Button from 'components/ui/button';

type Props = {
  id?: string;
  player?: string;
  returnTotal?: (value: number) => void;
  cycleLabel: string;
};

export function GroupDetailModalExtrato({ player, returnTotal, cycleLabel }: Props) {
  const { user } = useAuth();
  const { openModal, closeModal } = useContext(ModalContext);

  const modalID = 'group-detail-extrato';

  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const [data, setData] = useState<any>([]);

  ReactModal.setAppElement('#modal');

  function handleCloseModal() {
    //
  }

  function afterOpenModal() {
    //
  }

  useEffect(() => {
    setIsOpen(openModal === modalID);
  }, [openModal]);

  useEffect(() => {
    async function loadUserGroup() {
      if (user?._id || player) {
        const data = await getUserGroupList(player, cycleLabel);
        setData(data);

        if (returnTotal) {
          returnTotal(data?.length);
        }
      }
    }

    if (!user || !cycleLabel || !modalIsOpen) return;

    loadUserGroup();
  }, [user, player, cycleLabel, returnTotal, modalIsOpen]);

  if (!data?.length) return <></>;

  return (
    <>
      <ReactModal
        shouldCloseOnOverlayClick={false}
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={handleCloseModal}
        contentLabel="Example Modal"
        portalClassName="relative z-50"
        overlayClassName="fixed z-100 top-0 left-0 bg-black bg-opacity-80 flex flex-col items-center   w-screen h-screen p-6 pt-[10vh] overflow-y-auto"
        contentElement={() => (
          <Box className="w-[90%] lg:w-auto lg:max-w-[800px] ">
            <Button
              color="primary"
              className="absolute -right-5 -top-5  rounded-r-full rounded-l-full w-10 h-10 p-0 flex justify-center items-center"
              onClick={() => closeModal()}
            >
              <IoIosClose color="white" size={40} />
            </Button>

            <div className="flex justify-center text-xl text-yellow">
              <h1>Grupo {data[0]?.grupo}</h1>
            </div>

            <div className="overflow-x-auto">
              <div className="border-electric-blue border rounded-xl w-[700px] lg:w-auto">
                <div className="flex font-bold">
                  <div className="w-36 flex items-center p-2 pl-5">Matrícula </div>
                  <div className="w-48 border-electric-blue border-l flex items-center p-2 pl-5">Nome</div>
                </div>

                {data.map((group: any) => (
                  <div className={`flex  border-electric-blue border-t font-thin`} key={group._id}>
                    <div className="nome-dependencia flex items-center justify-center w-36 p-2">{group.chave} </div>
                    <div className="prefixo border-electric-blue border-l flex  items-center w-48 p-2">{group.nome}</div>
                  </div>
                ))}
              </div>
            </div>

            <p className="mt-5 font-thin">
              Total de funcionários do grupo: <span className="text-yellow">{data?.length} pessoas.</span>
            </p>
          </Box>
        )}
      />
    </>
  );
}
